import { ReactNode, useEffect } from "react";

import classNames from "classnames";
import styles from "./ErrorPage.module.css";

import { ReactComponent as BadRobot } from "./assets/bad-robot.svg";
import { ReactComponent as Ground } from "./assets/ground.svg";

/** The `ErrorPage` component properties. */
export interface ErrorPageProps {
  /** The CSS class name. */
  readonly className?: string;
}

/** A component which displays the content of the general error page. */
export const ErrorPage = (props: ErrorPageProps): ReactNode => {
  const { className } = props;

  useEffect(() => {
    console.error("mission error");
  }, []);

  return (
    <div className={classNames(styles.root, "pageNotFound", className)}>
      <div className={classNames(styles.errorContainer, "errBlock")}>
        <p className={classNames(styles.errorCode, "errCode")}>Mission error, JUDI is stuck! Refreshing the page should resolve this issue.</p>
        <p className={classNames(styles.errorMessage, "errMsg")}>
          Refresh didn&apos;t work? Try quitting and reopening your browser, then logging in again. If JUDI still doesn&apos;t load, we may
          be having internal technical issues. Our deepest apologies!
        </p>
      </div>
      <BadRobot className={classNames(styles.errorRobot, "robot")} />
      <div className={classNames(styles.errorBackground, "background")}>
        <Ground className={classNames(styles.errorGround, "ground")} />
      </div>
    </div>
  );
};
